interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  id?: string;
  required?: boolean;
  testId?: string;
}

export function TextInput({ value, onChange, placeholder, id, required, testId }: TextInputProps) {
  return (
    <input
      id={id}
      type="text"
      placeholder={placeholder || ""}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full !border-0 ring-1 ring-inset ring-gray-300 rounded-lg px-4 !py-[10.5px] leading-6 text-[16px]"
      style={{ fontFamily: "TT Commons Pro" }}
      aria-required={required}
      data-testid={testId}
    />
  );
}
